import { render, staticRenderFns } from "./RoomEditTemplate.vue?vue&type=template&id=3b907992"
import script from "./RoomEditTemplate.vue?vue&type=script&lang=ts"
export * from "./RoomEditTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports